<template>
<layout-content>
  <template #headerTitle>
    <h1 class="layout-content-header-text">{{$route.meta.label}}</h1>

    <section class="legend-list-wrapper">
      <span>审核状态:</span>
      <section class="audit-legend-item info"><div class="legend-section"></div>未审核</section>
      <section class="audit-legend-item success"><div class="legend-section"></div>已审核</section>
    </section>
  </template>

  <template #toolbar>
    <el-date-picker
      v-model="query.dateTime"
      type="month"
      format="yyyy年MM月"
      value-format="yyyy/MM/dd"
      :clearable="false"
      :editable="false"
      size="small"
      style="width:150px;"
      @change="onAuditTimeChanged"
    />

    <el-select
      v-model="query.siteId"
      size="small"
      style="width:170px;margin-left:.5rem;"
      @change="onAuditTimeChanged"
    >
      <el-option
        v-for="site in profileSites"
        :key="site.id"
        :value="site.id"
        :label="site.name"
      />
    </el-select>
  </template>

  <template #body>
    <section class="body-inner">
      <section class="calendar-chart" ref="contentBody">
        <div class="calendar-header">
          <div style="font-weight: bold;">
            {{new Date(query.dateTime).getFullYear()}}年{{new Date(query.dateTime).getMonth() + 1}}月
          </div>
          <div>
            <el-button size="mini" @click="onPrevClick">上一月</el-button>
            <el-button size="mini" @click="onNextClick">下一月</el-button>
            <el-button size="mini" @click="onCurrentClick">今天</el-button>
          </div>
        </div>
        <div class="calendar">
          <el-calendar
            v-model="query.dateTime"
            style="height: 100%;display: grid;grid-template-columns: 100%;grid-template-rows: 100%;"
          >
            <template
              slot="dateCell"
              slot-scope="{date, data}"
            >
              <div @click="onDateClick(date)">
                <div class="day">{{new Date(date).format('DD')}}</div>
                <div class="chart">
                  <div
                    :style="{
                      height: `${clientHeight > 530 ? '80px' : '50px'}`
                    }"
                  >
                    <audit-overview-chart
                      ref="AuditOverviewChart"
                      :day="date"
                      :data="chartData"
                      :client-height="clientHeight"
                    />
                  </div>
                </div>
              </div>
            </template>
          </el-calendar>
        </div>
      </section>
      <section class="list">
        <div
          style="width: 100%;background: #f9f9f9;color: #303030;padding: 5px;text-align: center;margin-bottom: .5em;font-weight: bold;"
        >
          {{new Date(currentDate).format('YYYY')}}年{{new Date(currentDate).format('MM')}}月{{new Date(currentDate).format('DD')}}日
          (
            <span style="color: #67c23a;">{{dataObj.auditDevices.length}}</span>
            /
            <span style="color: #909399;">{{dataObj.noAuditDevices.length}}</span>
          )
        </div>
        <p
          v-for="item in dataObj.auditDevices"
          :key="item.id"
          style="color: #67c23a;"
        >
          <section class="audit-legend-item success"><div class="legend-section"></div>{{item.name}}</section>
        </p>
        <p
          v-for="item in dataObj.noAuditDevices"
          :key="item.id"
          style="color: #909399;"
        >
          <section class="audit-legend-item info"><div class="legend-section"></div>{{item.name}}</section>
        </p>
      </section>
    </section>
  </template>
</layout-content>
</template>

<script>

import BaseStore from '../../../components/BaseStore'
import LayoutContent from '../../../components/Layout/Content'
import DataWrapper from '../../../components/Data/DataWrapper'
import AuditOverviewChart from '../../../components/Data/AuditOverviewChart'

export default {
  name: 'DataAuditAuditOverview',
  routeInfo: {
    label: '审核纵览',
    icon: 'fa fa-calendar'
  },
  extends: BaseStore,
  components: {DataWrapper, LayoutContent, AuditOverviewChart},
  data () {
    let date = new Date()
    date.setDate(date.getDate() - 1)
    return {
      query: {
        dateTime: date.format('YYYY/MM/DD'),
        siteId: ''
      },
      currentDate: date.format('YYYY/MM/DD'),
      maxAuditStage: 0,
      chartData: {},
      dataObj: {
        AuditTotalNum: 0,
        overAuditNum: 0,
        auditDevices: [],
        noAuditNum: 0,
        noAuditDevices: []
      },
      clientWidth: 0,
      clientHeight: 0,
      cellWidth: 0
    }
  },
  computed: {
    profileDevicesIdMap () {
      return this.profileSiteDevices.reduce((map, device) => {
        map[device.deviceId] = device
        return map
      }, {})
    }
  },
  watch: {
    profileSites: {
      immediate: true,
      handler (newVal) {
        if (newVal.length > 0) {
          this.query.siteId = newVal[0].id
          this.getData()
        }
      }
    }
  },
  methods: {
    onAuditTimeChanged () {
      this.getData()
    },
    onPrevClick () {
      let date = new Date(this.query.dateTime)
      let year = date.getFullYear()
      let month = date.getMonth()
      this.query.dateTime = new Date(year, month - 1, 1).format('YYYY/MM/DD')
      this.currentDate = Object.freeze(new Date(year, month - 1, 1).format('YYYY/MM/DD'))
      this.getData()
    },
    onNextClick () {
      let date = new Date(this.query.dateTime)
      let year = date.getFullYear()
      let month = date.getMonth()
      this.query.dateTime = new Date(year, month + 1, 1).format('YYYY/MM/DD')
      this.currentDate = Object.freeze(new Date(year, month + 1, 1).format('YYYY/MM/DD'))
      this.getData()
    },
    onCurrentClick () {
      let date = new Date()
      let year = date.getFullYear()
      let month = date.getMonth()
      let day = date.getDate()
      this.query.dateTime = new Date(year, month, day - 1).format('YYYY/MM/DD')
      this.currentDate = Object.freeze(new Date(year, month, day - 1).format('YYYY/MM/DD'))
      this.getData()
    },
    onDateClick (date) {
      let query = {
        auditTime: new Date(date).format('YYYY/MM/DD'),
        siteId: this.query.siteId
      }
      this.currentDate = Object.freeze(new Date(date).format('YYYY/MM/DD'))
      let {profileDevicesIdMap, auditAuth, maxAuditStage} = this
      this.$api.Audit.getAuditSiteDevices(query).then(data => {
        let temp = {
          dateTime: new Date(date).format('YYYY/MM/DD'),
          AuditTotalNum: data.length,
          overAuditNum: 0,
          auditDevices: [],
          noAuditNum: data.length,
          noAuditDevices: []
        }
        if (this.isAdmin || ((1 << (maxAuditStage - 1)) & auditAuth)) {
          data.forEach(el => {
            if (el.hasOwnProperty('auditInfos') && el.auditInfos.length > 1) {
              let isAudit = el.auditInfos.every(item => item.status)
              if (isAudit) {
                temp.overAuditNum += 1
                temp.noAuditNum -= 1
                temp.auditDevices.push({
                  name: profileDevicesIdMap[el.deviceId].name,
                  deviceId: el.deviceId,
                  id: el.id
                })
              } else {
                temp.noAuditDevices.push({
                  name: profileDevicesIdMap[el.deviceId].name,
                  deviceId: el.deviceId,
                  id: el.id
                })
              }
            } else {
              temp.noAuditDevices.push({
                name: profileDevicesIdMap[el.deviceId].name,
                deviceId: el.deviceId,
                id: el.id
              })
            }
          })
        } else {
          data.forEach(el => {
            if (el.hasOwnProperty('auditInfos')) {
              let isAudit = el.auditInfos.find(item => item.stage === 1 && item.status)
              if (isAudit) {
                temp.overAuditNum += 1
                temp.noAuditNum -= 1
                temp.auditDevices.push({
                  name: profileDevicesIdMap[el.deviceId].name,
                  deviceId: el.deviceId,
                  id: el.id
                })
              } else {
                temp.noAuditDevices.push({
                  name: profileDevicesIdMap[el.deviceId].name,
                  deviceId: el.deviceId,
                  id: el.id
                })
              }
            } else {
              temp.noAuditDevices.push({
                name: profileDevicesIdMap[el.deviceId].name,
                deviceId: el.deviceId,
                id: el.id
              })
            }
          })
        }

        this.dataObj = Object.freeze(temp)
      }).catch(console.error)
    },
    getData () {
      this.changeLoadStatus(true)
      this.$api.Audit.getMonthAuditStatus(this.query).then(data => {
        this.formatData(data)
        this.onDateClick(this.query.dateTime)
      }).catch(console.error).finally(() => {
        this.changeLoadStatus(false)
      })
    },
    formatData (data) {
      let {profileSiteDevices, query: {siteId, dateTime}, auditAuth, maxAuditStage} = this

      let profileSiteDevicesMap = profileSiteDevices.reduce((map, device) => {
        if (!map[device.siteId]) {
          map[device.siteId] = []
        }

        if (device.status && device.categoryId !== 2) {
          map[device.siteId].push(device)
        }
        return map
      }, {})

      // let dataDateMap = data.reduce((map, item) => {
      //   if (!map[item.auditTime]) {
      //     map[item.auditTime] = []
      //   }

      //   map[item.auditTime].push(item)
      //   return map
      // }, {})

      // 数据补全
      let date = new Date(dateTime)
      let year = date.getFullYear()
      let month = date.getMonth()
      let startDate = new Date(year, month).getTime()
      let endDate = new Date(year, month + 1, 0).getTime()
      let tsStep = 60 * 60000 * 24

      let dateData = {}
      for (let ts = startDate; ts <= endDate; ts += tsStep) {
        let temp = new Date(ts).format('YYYY-MM-DD')
        dateData[temp] = {
          dataTime: new Date(ts).format('YYYY-MM-DD'),
          AuditTotalNum: profileSiteDevicesMap[siteId].length,
          overAuditNum: 0,
          noAuditNum: profileSiteDevicesMap[siteId].length
        }
      }

      if (this.isAdmin || ((1 << (maxAuditStage - 1)) & auditAuth)) {
        data.forEach(el => {
          let ts = new Date(el.auditTime).format('YYYY-MM-DD')

          if (el.isAuditOver) {
            dateData[ts].noAuditNum = dateData[ts].noAuditNum - 1
            dateData[ts].overAuditNum += 1
          }
        })

        this.chartData = Object.freeze(dateData)
      } else {
        data.forEach(el => {
          let ts = new Date(el.auditTime).format('YYYY-MM-DD')
          let auditInfo = el.auditInfos.find(item => item.stage === 1)

          if (auditInfo && auditInfo.status) {
            dateData[ts].noAuditNum = dateData[ts].noAuditNum - 1
            dateData[ts].overAuditNum += 1
          }
        })

        this.chartData = Object.freeze(dateData)
      }
      this.windowRize()
    },
    getDataRenders () {
      return this.$refs.AuditOverviewChart
    },
    renderData () {
      setTimeout(() => {
        let dataRenders = this.getDataRenders()

        if (dataRenders) {
          dataRenders.render()
        }
      }, 0)
    },
    windowRize () {
      let contentBody = this.$refs.contentBody
      let clientWidth = contentBody.clientWidth
      let clientHeight = contentBody.clientHeight
      this.clientWidth = clientWidth
      this.clientHeight = clientHeight
    }
  },
  created () {
    this.$api.User.getMaxAuditStage().then(maxAuditStage => {
      this.maxAuditStage = maxAuditStage
    }).catch(console.error)

    window.addEventListener('resize', this.windowRize)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.windowRize)
  }
}
</script>

<style lang="scss" scoped>
.layout-content-wrapper /deep/ .layout-content-body {
  padding: 1em;
}
.legend-list-wrapper {
  font-size: .875em;
  display: flex;
  align-items: center;
  float: left;
  height: 100%;
  line-height: 2rem;
  margin-left: 2em;
  color: #303133;
  user-select: none;

  > .audit-legend-item {
    display: flex;
    align-items: center;
    float: left;
    margin-left: 1em;

    &.info {
      > .legend-section {
        background-color: #909399;
      }
    }

    &.success {
      > .legend-section {
        border: 1px solid #67C23A;
        background-color: #67C23A;
      }
    }

    > .legend-section {
      display: inline-block;
      width: .75em;
      height: .75em;
      margin-right: .5em;
      vertical-align: middle;
      border: 1px solid #909399;
    }
  }
}
.body-inner {
  width: 100%;
  height: 100%;
  display: grid;
  grid-template-columns: auto max-content;
  grid-template-rows: 100%;
  grid-gap: 10px;
  overflow: auto;

  .calendar-chart {
    width: 100%;
    height: 100%;
    display: grid;
    grid-template-columns: 100%;
    grid-template-rows: max-content auto;
    grid-gap: 5px;
    overflow: auto;

    .calendar-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      border-bottom: 1px solid #EBEEF5;
      height: 53px;
    }

    .calendar {
      width: 100%;
      height: 100%;
      overflow: auto;
    }

    /deep/ .el-calendar {
      height: 100%;

      > .el-calendar__header {
        display: none;
      }
    }

    /deep/ .el-calendar__body {
      height: 100%;
      padding: 0;

      .el-calendar-table {
        width: 100%;
        height: 100%;
        .el-calendar-table__row {
          .prev, .next {
            pointer-events: none;

            > div {
              display: none;
            }
          }
        }

        .el-calendar-day {
          width: 100%;
          height: 100%;

          > div {
            width: 100%;
            height: 100%;
            display: grid;
            grid-template-columns: 20px auto;
            grid-template-rows: 100%;
            grid-gap: 1px;

            .day {
              font-size: 1em;
            }

            > .chart {
              // border: 1px solid red;
              width: 100%;
              height: 100%;
              display: flex;
              align-items: center;

              > div {
                width: 100%;
                height: 40px;
              }
            }
          }
        }
      }
    }
  }

  .list {
    width: 300px;
    user-select: none;
    border: 1px solid #EBEEF5;
    padding-bottom: 10px;
    overflow: auto;

    > p {
      margin: 0 0 9px 10px;
      font-size: 17px;

      > .audit-legend-item {
        display: flex;
        align-items: center;
        margin-left: 1em;

        &.info {
          > .legend-section {
            background-color: #909399;
          }
        }

        &.success {
          > .legend-section {
            border: 1px solid #67C23A;
            background-color: #67C23A;
          }
        }

        > .legend-section {
          width: .75em;
          height: .75em;
          margin-right: .5em;
          vertical-align: middle;
          border: 1px solid #909399;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/02Data-Audit/02AuditOverview/index.vue